import type { ElementType, ReactNode } from 'react'

import { Fragment } from 'react'
import { cn } from '@/lib/utils'

interface SplitWordsProps {
    /** Each entry renders as its own line, so the source line breaks are preserved. */
    lines: string[]
    as?: ElementType
    className?: string
    lineClassName?: string
    [key: `data-${string}`]: unknown
}

/**
 * Renders a headline as per-word clipping masks so a section timeline can slide
 * each word up from behind its own mask. The full sentence stays in the DOM as
 * readable text, so screen readers and search engines see it unchanged.
 */
export const SplitWords = ({
    lines,
    as: Tag = 'span',
    className,
    lineClassName,
    ...rest
}: SplitWordsProps): ReactNode => {
    return (
        <Tag className={className} data-split='' {...rest}>
            {lines.map((line, lineIndex) => (
                <span
                    key={`${line}-${lineIndex}`}
                    className={cn('block', lineClassName)}
                >
                    {line.split(' ').map((word, wordIndex, all) => (
                        <Fragment key={`${word}-${wordIndex}`}>
                            <span className='reveal-mask'>
                                <span>
                                    {word}
                                </span>
                            </span>

                            {wordIndex < all.length - 1 ? ' ' : null}
                        </Fragment>
                    ))}
                </span>
            ))}
        </Tag>
    )
}
